<script setup>
// Second step for the code formats more than one provider shares. Only ever triggered by
// the pairs that share an adapter, where trying each in turn genuinely cannot tell them
// apart, but lists every provider the format fits once it is - every other multi-candidate
// code is resolved without asking, because "who issued this?" is a question a gift
// recipient often cannot answer.
//
// Shared by both journeys that resolve a voucher code - see RedeemPinPanel.vue.

const props = defineProps({
    code: { type: String, required: true },
    // In matcher rank order, highest volume first.
    providers: { type: Array, required: true },
    // The createVoucherFlow() instance driving this journey - see shared/voucherFlow.js.
    flow: { type: Object, required: true },
});

const state = props.flow.state;

function choose(provider) {
    props.flow.submit({ code: props.code, provider: provider.slug });
}
</script>

<template>
    <div class="redeem_panel">
        <p class="redeem_panel_intro">
            More than one of our partners issues vouchers numbered like
            <strong>{{ code }}</strong>. Who is yours from?
        </p>

        <ul class="redeem_provider_list">
            <li v-for="provider in providers" :key="provider.slug">
                <button
                    type="button"
                    class="button teal"
                    :disabled="state.busy"
                    @click="choose(provider)"
                >
                    {{ provider.name }}
                </button>
            </li>
        </ul>

        <p v-if="state.error" class="redeem_panel_error">{{ state.error }}</p>
    </div>
</template>
